import React, { useCallback, useMemo, useState } from "react";
import ReactDropdown from "react-dropdown";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import Modal from "react-bootstrap/Modal";
import NumberFormat from "react-number-format";

export const SearchBarDesktop = ({
    dataSearch, setDataSearch, onSearch,
    dsNhanVien, dsKieuGiaoDich, dsLoaiGiaoDich
}) => {
    const today = new Date();
    const [showModal, setShowModal] = useState(false); // State cho Modal mobile

    const toggleModal = () => setShowModal(!showModal);

    // --- CÁC HÀM XỬ LÝ (GIỮ NGUYÊN) ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDataSearch(prev => ({ ...prev, [name]: value }));
    };

    const handleDateChange = (field) => (date) => {
        setDataSearch(prev => ({ ...prev, [field]: date }));
    };

    const handleSearch = useCallback(() => {
        const newSearchData = { ...dataSearch, pageIndex: 1 };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
        if (showModal) toggleModal(); // Đóng modal nếu đang ở mobile
    }, [onSearch, dataSearch, setDataSearch, showModal]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    const handleDropdownChange = (field) => (option) => {
        if (option && typeof option.value !== 'undefined') {
            setDataSearch(prev => ({ ...prev, [field]: option.value }));
        }
    };

    // --- OPTIONS (GIỮ NGUYÊN) ---
    const typeMoneyOptions = [
        { value: "=", label: "=" },
        { value: ">", label: ">" },
        { value: "<", label: "<" },
        { value: "#", label: "#" },
    ];
    const selectedTypeMoneyOption = useMemo(() => {
        return typeMoneyOptions.find(opt => opt.value === dataSearch.typeMoney) || typeMoneyOptions[0];
    }, [dataSearch.typeMoney]);

    const employeeOptions = useMemo(() => {
        return [{ label: 'Tất cả', value: '' }, ...dsNhanVien];
    }, [dsNhanVien]);

    const selectedEmployeeOption = useMemo(() => {
        return employeeOptions.find(opt => opt.value === (dataSearch.employee ?? '')) || employeeOptions[0];
    }, [employeeOptions, dataSearch.employee]);

    const selectedTransactionTypeOption = useMemo(() => {
        if (!dsKieuGiaoDich || dsKieuGiaoDich.length === 0) return undefined;
        return dsKieuGiaoDich.find(opt => opt.value === dataSearch.transactionType) || dsKieuGiaoDich[0];
    }, [dsKieuGiaoDich, dataSearch.transactionType]);

    const selectedLoaiGiaoDichOption = useMemo(() => {
        if (!dsLoaiGiaoDich || dsLoaiGiaoDich.length === 0) return undefined;
        return dsLoaiGiaoDich.find(opt => opt.value === dataSearch.loaiGiaoDich) || dsLoaiGiaoDich[0];
    }, [dsLoaiGiaoDich, dataSearch.loaiGiaoDich]);

    const renderFormFields = () => (
        <>
            <div className="input-sm-new" style={{ flex: 1 }}>
                <label className="font-color-default font-bold">Tên khách hàng, mã HĐ</label>
                <input
                    type="text"
                    name="customerName"
                    value={dataSearch.customerName}
                    onChange={handleInputChange}
                    className="form-control input-sm"
                    placeholder="Nhập tên hoặc mã"
                />
            </div>
            <div className="input-sm-new d-flex flex-row" style={{ flex: 1, minWidth: '170px' }}>
                <div style={{ flex: '70%' }}>
                    <label className="font-color-default font-bold">Số tiền</label>
                    <NumberFormat
                        className="form-control input-sm"
                        placeholder="Nhập số tiền"
                        thousandSeparator={true}
                        value={dataSearch.money || ''} 
                        onValueChange={(values) => {
                            setDataSearch(prev => ({ ...prev, money: values.value }));
                        }}
                    />
                </div>
                <div style={{ marginLeft: 3, flex: '30%', minWidth: '50px', alignSelf: 'flex-end' }}>
                    <ReactDropdown
                        options={typeMoneyOptions}
                        onChange={handleDropdownChange("typeMoney")}
                        value={selectedTypeMoneyOption}
                        controlClassName="form-control input-sm"
                    />
                </div>
            </div>
            <div className="input-sm-new" style={{ flex: 1, minWidth: '110px' }}>
                <label className="font-color-default font-bold">Từ ngày</label>
                <DateTimePicker
                    value={dataSearch.fromDate}
                    onChange={handleDateChange("fromDate")}
                    placeholder="Ngày bắt đầu"
                    maxDate={dataSearch.toDate || today}
                />
            </div>
            <div className="input-sm-new" style={{ flex: 1, minWidth: '110px' }}>
                <label className="font-color-default font-bold">Đến ngày</label>
                <DateTimePicker
                    value={dataSearch.toDate}
                    onChange={handleDateChange("toDate")}
                    placeholder="Ngày kết thúc"
                    minDate={dataSearch.fromDate}
                    maxDate={today}
                />
            </div>
            <div className="input-sm-new" style={{ flex: 1 }}>
                <label className="font-color-default font-bold">Nhân viên</label>
                <ReactDropdown
                    options={employeeOptions}
                    onChange={handleDropdownChange("employee")}
                    value={selectedEmployeeOption}
                    controlClassName="form-control input-sm custom-dropdown-truncate"
                />
            </div>
            <div className="input-sm-new" style={{ flex: 1, minWidth: '150px' }}>
                <label className="font-color-default font-bold">Kiểu Giao Dịch</label>
                <ReactDropdown
                    options={dsKieuGiaoDich}
                    onChange={handleDropdownChange("transactionType")}
                    value={selectedTransactionTypeOption}
                    controlClassName="form-control input-sm custom-dropdown-truncate"
                    placeholder={dsKieuGiaoDich.length === 0 ? "Loading..." : "Chọn kiểu"}
                />
            </div>
            <div className="input-sm-new" style={{ flex: 1, minWidth: '150px', maxWidth: '200px' }}>
                <label className="font-color-default font-bold">Loại Giao Dịch</label>
                <ReactDropdown
                    options={dsLoaiGiaoDich}
                    onChange={handleDropdownChange("loaiGiaoDich")}
                    value={selectedLoaiGiaoDichOption}
                    controlClassName="form-control input-sm custom-dropdown-truncate"
                    placeholder={dsLoaiGiaoDich.length === 0 ? "Loading..." : "Chọn loại"}
                />
            </div>
        </>
    );

    return (
        <>
            <style>
                {`
                    .search-bar-unique-wrapper .custom-dropdown-truncate .Dropdown-placeholder, 
                    .search-bar-unique-wrapper .custom-dropdown-truncate .is-selected {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 100%;
                        display: block;
                        padding-right: 15px;
                    }
                    .search-bar-unique-wrapper .custom-dropdown-truncate {
                         display: flex;
                         align-items: center;
                         overflow: hidden;
                    }
                    .search-bar-unique-wrapper .Dropdown-menu {
                        width: max-content;
                        max-width: 300px;
                        min-width: 100%;
                        overflow-x: hidden;
                    }
                `}
            </style>

            <div className="card border-light mb-1 show-table-main card-v2 hidden-mobile-main" onKeyDown={handleKeyDown}>
                <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                    <div className="search-new d-flex flex-wrap align-items-end gap-2 search-bar-unique-wrapper" style={{ paddingBottom: '5px' }}>
                        {renderFormFields()}
                        <div className="input-sm-new" style={{ marginTop: 5 }}>
                            <button
                                type="button"
                                className="btn btn-info-new"
                                style={{ paddingTop: "7px", whiteSpace: 'nowrap' }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; Tìm kiếm</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="card border-light mb-1 show-table-main card-v2">
                    <div className="card-body card-body-v2">
                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                onClick={toggleModal}
                            >
                                Tìm kiếm <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={toggleModal}
                dialogClassName="modal-lg"
                className="modal-new modal fade text-left"
                backdrop="static"
            >
                <Modal.Header>
                    <h2 className="modal-title p-1">Tìm kiếm</h2>
                    <button type="button" className="close-popup-new" onClick={toggleModal}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="search-new d-flex flex-column gap-3">
                        {renderFormFields()}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={handleSearch}
                    >
                        <i className="fas fa-search"></i> Tìm kiếm
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                        <i className="fas fa-times"></i> Đóng
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};